import axios from 'axios';
import { getAxiosWithCache } from '../axios';

import { API_URL } from '../config';
import { generateDateString } from '../helpers/dates';

const ax = axios.create(); // to bypass humps
const axiosWithCache = getAxiosWithCache();

const URL_DESTINATIONS = `${API_URL}/destination`;
const URL_TRAVEL_PRICE = `${API_URL}/price/travel`;

export const fetchDestinations = () => axiosWithCache.get(URL_DESTINATIONS).then((response) => {
  const { destinations } = response.data;
  return destinations.map((dest) => ({
    id: dest.id,
    country: {
      id: dest.country.id,
      nameEN: dest.country.nameEN,
      nameRU: dest.country.nameRU,
      nameHY: dest.country.nameHY,
    },
    region: {
      id: dest.region.id,
    },
    code: dest.code,
  }));
});

export const requestPrices = (payload) => {
  const travelers = payload.travelers
    .map((el) => ({ ...el, birthday: generateDateString(el.birthday) }));
  const modifiedPayload = {
    travelers,
    destination: payload.region,
    days: payload.days,
    quoteRequests: payload.quoteRequests,
    promoCodes: payload.promoCodes,
    travelPolicyStart: payload.travelPolicyStart,
    travelPolicyEnd: payload.travelPolicyEnd,
  };

  return ax
    .post(URL_TRAVEL_PRICE, modifiedPayload)
    .then((response) => response.data.result);
};
